define([
	"dojo/_base/declare",
	"csi/property/Widget",
	"./ProductProperties"
], function(declare, Widget, ProductProperties) {

	return declare(Widget, {
		_buildColumns: function(/*Context*/ctx) {
			// summary: use ProductProperties so that title is shown - otherwise could use default
			return ProductProperties.details(ctx, this.columnsNode, 2);
		}
	});
});